/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {VendorDetailView} from "../../vendor/views/VendorDetailView";
const route = [{bundlerEntry: "vendorDetail", path: rpAppPath.vendor.detail.base, component: VendorDetailView}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {VendorDetailView} from "../../vendor/views/VendorDetailView";
const route = [{bundlerEntry: "vendorDetail", path: rpAppPath.vendor.detail.base, component: VendorDetailView}];

(function () {
    rpClient(route);
})();
